<template>
	<div class="chat-online-block">
		<div class="title">Онлайн:&nbsp;{{ onlineList.length }}</div>
		<ul class="chat-online-list">
			<li v-for="user in onlineList" :key="user.member_id">
				<svg-icon :class="['star', statusClasses(user)]" :name="starForUser(user)"/>
				<div v-if="user.user_id > 0">
					<a :href="'//sinair.net/profile/' + user.user_id" :style="{color: user.color}" target="_blank">
						{{ user.name }}
					</a>
				</div>
				<div v-else :style="{color: user.color}">{{ user.name }}</div>
			</li>
		</ul>
	</div>
</template>

<script>
import SvgIcon from './SvgIcon';

import eventBus from '../eventbus';
import {UserStatus} from '@iassasin/wschatapi';

export default {
	components: {
		SvgIcon,
	},

	data() {
		return {
			state: eventBus.state,
			size: 16,
			fill: 'red',
		};
	},

	computed: {
		onlineList() {
			let result = [...this.state.onlineList];
			return result.sort((a, b) => (b.is_owner * 2 + b.is_moder) - (a.is_owner * 2 + a.is_moder));
		},
	},

	methods: {
		statusClasses(user) {
			switch (user.status) {
				case UserStatus.away: return 'status-away';
				case UserStatus.orphan: return 'status-orphan';
			}
			return 'status-online';
		},

		starForUser(user) {
			if (user.is_owner) {
				return 'star5';
			} else if (user.is_moder) {
				return 'star4';
			}

			return 'star0';
		},
	},
}
</script>

<style lang="less" scoped>
.title {
	margin-bottom: 10px;
}

.chat-online-block {
	flex: auto;
	overflow-y: auto;

	ul.chat-online-list {
		padding: 0;
		margin: 0;

		> li {
			list-style: none;
			margin: 8px 0px;
			line-height: 1.15em;
			word-wrap: break-word;

			display: flex;
			flex-direction: row;
			align-items: center;

			> * {
				flex: auto;
			}
		}

		span.star {
			flex: none;
			display: inline-block;
			text-align: center;
			width: 14px;
			height: 14px;
			margin-right: 5px;

			&.status-online {
				fill: #3f0;
			}

			&.status-away {
				fill: gray;
			}

			&.status-orphan {
				fill: transparent;
				stroke: gray;
			}
		}
	}
}
</style>
